export default {
  path: '/home/userRisk/monitorStrategy',
  component: () => import('./MonitorStrategy/index.vue'),
  meta: { titie: '监控策略' },
}
